module.exports = __webpack_public_path__ + "img/print-slash.67590477.svg";